module.exports = __webpack_public_path__ + "uK9sO6mmf5L0OqWIh/agent-training-center_about_referral_manager.png";